module.exports = {
          srcSet: __webpack_public_path__ + "668a497a025a00192cd49365e8862945-32.png"+" 32w",
          images:[ {path: __webpack_public_path__ + "668a497a025a00192cd49365e8862945-32.png",width: 32,height: 30}],
          src: __webpack_public_path__ + "668a497a025a00192cd49365e8862945-32.png",
          toString:function(){return __webpack_public_path__ + "668a497a025a00192cd49365e8862945-32.png"},
          
          width: 32,
          height: 30
        }